import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const HeatingPage = () => <ServicePageTemplate data={servicePageData['heating']} />;
export default HeatingPage;
